<template>
  <div>
    <el-steps :active="rechargeStep" simple finish-status="success" class="step-bar">
      <el-step title="选择套餐"></el-step>
      <el-step title="扫码支付"></el-step>
      <el-step title="充值完成"></el-step>
    </el-steps>
    <div v-if="rechargeStep===0">
      <div v-if="mealInfo.length === 0" class="no-meal-tip">
        <i class="el-icon-warning-outline" style="font-size:40px;color:#e6a23c;margin-bottom:12px;"></i>
        <p>暂无套餐，请联系客服充值</p>
        <el-button type="primary" size="small" @click="goCustomService">联系客服</el-button>
      </div>
      <div v-else class="meal-grid">
        <div v-for="item in mealInfo" :key="item.mealId" class="meal-item"
          :class="{selected: item.mealId === selectedMealId}" @click="selectedMealId = item.mealId">
          <div class="name">{{ item.mealName }}</div>
          <div class="price"><small>¥</small>{{ item.currentPrice / 100 }}</div>
          <div class="point">{{ item.point }} 积分</div>
          <div class="limit">{{ item.limitBuyCount !== -1 ? '限购' + item.limitBuyCount + '次' : '不限购买次数' }}</div>
        </div>
      </div>
      <div style="color:#909399;font-size:12px;line-height:1.8;">
        {{ feeText }}
      </div>
    </div>
    <div v-if="rechargeStep===1" style="text-align:center;padding:30px 0;">
      <div id="qrcode" ref="qrcode" style="width:200px;height:200px;background:#f5f5f5;border-radius:8px;margin:0 auto 16px;display:flex;align-items:center;justify-content:center;">
        <i class="el-icon-picture-outline" style="font-size:60px;color:#dcdfe6;"></i>
      </div>
      <p style="color:#909399;font-size:13px;">请使用微信扫码支付</p>
      <p style="color:#c0c4cc;font-size:12px;margin-top:4px;">支付完成后将自动跳转</p>
    </div>
    <div v-if="rechargeStep===2" style="text-align:center;padding:30px 0;">
      <i class="el-icon-circle-check" style="font-size:60px;color:#52c41a;margin-bottom:12px;"></i>
      <p style="font-size:16px;color:#303133;">充值成功！</p>
      <p style="color:#909399;font-size:13px;margin-top:4px;">积分将在5分钟内到账</p>
    </div>
    <div slot="footer" class="recharge-footer" v-if="rechargeStep===0 || rechargeStep===1">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button v-if="rechargeStep===0 && mealInfo.length > 0" type="primary" size="small" @click="doPay">下一步</el-button>
    </div>
    <div slot="footer" class="recharge-footer" v-if="rechargeStep===2">
      <el-button type="primary" size="small" @click="cancel">完成</el-button>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  components: { QRCode },
  props: {
    pointType: { type: Number, default: null }
  },
  computed: {
    // 年报点数(10)费率与SCRM点数不同
    feeText() {
      return this.pointType === 10
        ? '积分消费说明：A=1积分，B=2积分，C=4积分'
        : '积分消费说明：A=1积分，B=5积分，C=10积分'
    }
  },
  data() {
    return {
      mealInfo: [],
      selectedMealId: null,
      rechargeStep: 0,
      rechargeId: '',
      pollingTimer: null
    }
  },
  created() {
    this.$http.getPointMealAllList(this.pointType ? { pointType: this.pointType } : null).then(r => { this.mealInfo = r.data || [] })
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    doPay() {
      if (!this.selectedMealId) { this.$message.error('请选择套餐'); return }
      this.$http.wxPay({ mealId: this.selectedMealId }).then(r => {
        if (r.status === 'success') {
          this.rechargeId = r.data.rechargeId
          this.rechargeStep = 1
          this.$emit('renew')
          setTimeout(() => {
            const el = document.getElementById('qrcode')
            if (el) {
              el.innerHTML = ''
              new QRCode(el, { width: 200, height: 200, text: r.data.payUrl })
            }
          }, 100)
          this.startPolling()
        } else { this.$message.error(r.msg) }
      })
    },
    startPolling() {
      this.stopPolling()
      this.pollingTimer = setInterval(() => {
        this.$http.wxPayQueryStatus(this.rechargeId).then(r => {
          if (r.status === 'success' && r.data && r.data.payStatus === 1) {
            this.stopPolling()
            this.rechargeStep = 2
            this.$emit('renew')
          }
        }).catch(() => {})
      }, 3000)
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    goCustomService() {
      this.$emit('close')
      this.$router.push('/custom-service').catch(() => {})
    },
    cancel() {
      this.stopPolling()
      this.rechargeStep = 0
      this.selectedMealId = null
      this.rechargeId = ''
      const el = document.getElementById('qrcode')
      if (el) el.innerHTML = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.step-bar { margin-bottom: 24px; }
.meal-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; margin: 20px 0; }
.meal-item { border: 1px solid #e8e8e8; border-radius: 10px; padding: 20px; text-align: center; cursor: pointer; transition: all 0.2s; }
.meal-item:hover { border-color: #409eff; }
.meal-item.selected { border-color: #409eff; background: #f0f7ff; }
.meal-item .name { font-size: 15px; font-weight: 600; color: #303133; margin-bottom: 6px; }
.meal-item .price { color: #409eff; font-size: 24px; font-weight: 700; }
.meal-item .price small { font-size: 14px; font-weight: normal; }
.meal-item .point { color: #909399; font-size: 13px; margin-top: 4px; }
.meal-item .limit { color: #409eff; font-size: 12px; margin-top: 4px; }
.no-meal-tip { text-align: center; padding: 40px 0; color: #909399; }
.no-meal-tip p { margin: 0 0 16px; font-size: 14px; }
.recharge-footer { text-align: right; }
</style>
